import React from 'react';
import get from 'lodash/get';

interface OtpInputProps {
    error: boolean;
    reset: boolean;
    otpLoader: boolean;
    disabled: boolean;
    verifyOtp: (otp: string) => void;
    resetError: () => void;
}

const initialState = {
    digit1: '',
    digit2: '',
    digit3: '',
    digit4: '',
    shouldShowError: false,
};

class OtpInput extends React.PureComponent<OtpInputProps> {
    firstDigit: React.RefObject<HTMLInputElement>;
    constructor(props: OtpInputProps) {
        super(props);
        this.firstDigit = React.createRef();
    }

    state = initialState;
    componentDidUpdate(prevProps: OtpInputProps): void {
        if (this.props.reset !== prevProps.reset) {
            if (this.props.reset) {
                this.setState({
                    ...initialState,
                });
                this.firstDigit.current?.focus();
            }
        }
        if (this.props.error !== prevProps.error) {
            if (this.props.error) {
                this.setState({
                    ...initialState,
                });
                this.firstDigit.current?.focus();
                this.props.resetError();
            }
        }
    }

    keyDownListener = (event: KeyboardEvent): void => {
        if (event.key === 'Backspace') {
            const target = event.target as HTMLInputElement;
            if (target && !target.value && !get(this.state, [target.name])) {
                const prevSibling = target.previousElementSibling as HTMLInputElement;
                if (prevSibling && typeof prevSibling.focus === 'function') {
                    prevSibling.focus();
                }
            }
        }
    };

    componentDidMount(): void {
        addEventListener('keydown', this.keyDownListener);
    }

    componentWillUnmount(): void {
        removeEventListener('keydown', this.keyDownListener);
    }

    onChange = ({ nativeEvent, target }: React.ChangeEvent<HTMLInputElement>): void => {
        // if (!get(nativeEvent, 'inputType')) {
        //     return;
        // } else {
        const sibling = target.nextElementSibling as HTMLInputElement;
        if (target.value && sibling && typeof sibling.focus === 'function') {
            sibling.focus();
        }

        this.props.resetError();

        this.setState(
            {
                [target.name]: target.value,
            },
            () => {
                if (target.name === 'digit4' && target.value) {
                    const { digit1, digit2, digit3, digit4 } = this.state;
                    this.props.verifyOtp(`${digit1}${digit2}${digit3}${digit4}`);
                }
            },
        );
        // }
    };

    render(): JSX.Element {
        return (
            <form id="otp">
                <div className="flex flex-row space-x-8">
                    <input
                        key="digit1"
                        ref={this.firstDigit}
                        className={`h-48 w-46 border ${
                            this.props.error ? 'border-status-warning text-status-warning' : ''
                        } border-neutral-4 rounded-8 outline-none border-neutral-5 text-center focus:border-actionPrimary`}
                        type="number"
                        autoComplete="off"
                        maxLength={1}
                        name={`digit1`}
                        value={get(this.state, [`digit1`])}
                        onChange={this.onChange}
                        autoFocus={true}
                        disabled={this.props.disabled}
                    />
                    <input
                        key="digit2"
                        className={`h-48 w-46 border ${
                            this.props.error ? 'border-status-warning text-status-warning' : ''
                        } border-neutral-4 rounded-8 outline-none border-neutral-5 text-center focus:border-actionPrimary`}
                        type="number"
                        autoComplete="off"
                        maxLength={1}
                        name={`digit2`}
                        value={get(this.state, [`digit2`])}
                        onChange={this.onChange}
                        disabled={this.props.disabled}
                    />
                    <input
                        key="digit3"
                        className={`h-48 w-46 border ${
                            this.props.error ? 'border-status-warning text-status-warning' : ''
                        } border-neutral-4 rounded-8 outline-none border-neutral-5 text-center focus:border-actionPrimary`}
                        type="number"
                        autoComplete="off"
                        maxLength={1}
                        name={`digit3`}
                        value={get(this.state, [`digit3`])}
                        onChange={this.onChange}
                        disabled={this.props.disabled}
                    />
                    <input
                        key="digit4"
                        className={`h-48 w-46 border ${
                            this.props.error ? 'border-status-warning text-status-warning' : ''
                        } border-neutral-4 rounded-8 outline-none border-neutral-5 text-center focus:border-actionPrimary`}
                        type="number"
                        autoComplete="off"
                        maxLength={1}
                        name={`digit4`}
                        value={get(this.state, [`digit4`])}
                        onChange={this.onChange}
                        disabled={this.props.disabled}
                    />
                </div>
            </form>
        );
    }
}

export default OtpInput;
